import React, { useState, useEffect } from "react";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import eyeIcon from "../../asessts/Images/eye_icon.svg";
import emptyIllustration from "../../asessts/Images/empty_illustration.jpg";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../../redux/slices/currentPageSlice";
import { setPageSlice } from "../../redux/slices/pageSlice";
import Pagination from "../../components/common/Pagination";
import { formatRole, formatRoleFitness } from "../../utils/common";

function Request() {
  const { state } = useLocation();
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [total, setTotal] = useState("");
  const [perPage] = useState(15);
  const [activeTab, setActiveTab] = useState(state?.activeTab || "Pending");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentPage = useSelector(
    (state) => state.currentPageSlice.currentPage
  );

  const fetchRequests = async (page = currentPage) => {
    setIsLoading(true);
    const url =
      activeTab === "Pending"
        ? `/admin/requests/get-requests?page=${page}`
        : `/admin/requests/get-approved-requests?page=${page}`;

    try {
      const response = await client.get(url);
      setPosts(response.data.data.requests);
      setTotal(response.data.data.total);
      dispatch(setPageSlice("request"));
    } catch (error) {
      console.error("Error while fetching requests:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests(currentPage);
  }, [activeTab, currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= Math.ceil(total / perPage)) {
      dispatch(setCurrentPage(newPage));
      navigate(`/request?page=${newPage}`, { state: { activeTab } });
    }
  };
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    dispatch(setCurrentPage(1));
    navigate(`/request?page=1`, { state: { activeTab: tab } });
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header title="Requests" />
        <div className="loaction-list-main">
          <div className="request-selection">
            <ul>
              <li
                className={activeTab === "Pending" ? "request-active" : ""}
                onClick={() => handleTabClick("Pending")}
              >
                Pending
              </li>
              <li
                className={activeTab === "Accepted" ? "request-active" : ""}
                onClick={() => handleTabClick("Accepted")}
              >
                Accepted
              </li>
            </ul>
          </div>

          <div className="table-data-main">
            {isLoading ? (
              <Loading />
            ) : posts.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px 20px" }}>
                <img
                  src={emptyIllustration}
                  alt="No requests found"
                  style={{ maxWidth: "400px", width: "100%", height: "auto" }}
                />
                <p style={{ marginTop: "20px", fontSize: "16px", color: "#666" }}>
                  No data found
                </p>
              </div>
            ) : (
              <>
                <div className="table-data">
                  <table border="0" cellPadding="0" style={{ width: "100%" }}>
                    <thead
                      style={{
                        backgroundColor: "#FDFDFD",
                        borderBottom: "1px solid #EDEDED",
                      }}
                    >
                      <tr>
                        <th className="heading">Request ID</th>
                        <th className="heading">Name</th>
                        <th className="heading">Role</th>
                        <th className="heading">Type</th>
                        <th className="heading">Phone Number</th>
                        <th className="heading" style={{ width: "7%" }}>
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {posts.map((post, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: "1px solid #EDEDED" }}
                        >
                          <td className="table-col">
                            <table>
                              <tbody>
                                <tr>
                                  <td
                                    className="rating"
                                    style={{ border: "none" }}
                                  >
                                    {post.profileId || "--"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="table-col">
                            {post.firstName} {post.lastName}
                          </td>
                          <td className="table-col">
                            {formatRole(post.role || "--")}
                          </td>
                          <td className="table-col">
                            {/* {post.facilityOrProfession
                              ? post.facilityOrProfession
                                  .charAt(0)
                                  .toUpperCase() +
                                post.facilityOrProfession.slice(1)
                              : ""} */}
                            {formatRoleFitness(
                              post.facilityOrProfession || "--"
                            )}
                          </td>

                          <td className="table-col">
                            {post?.phoneNumber?.number
                              ? `+${post.phoneNumber.dialCode} ${post.phoneNumber.number}`
                              : ""}
                          </td>

                          <td
                            style={{ textAlign: "center" }}
                            className="table-col"
                          >
                            <button className="action-btn">
                              <Link
                                to={`/request-detail-${post.facilityOrProfession}/${post.id}`}
                                state={{
                                  from: "/request",
                                  activeTab: activeTab,
                                }}
                              >
                                <img src={eyeIcon} alt="View" />
                              </Link>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  currentPage={currentPage}
                  perPage={perPage}
                  total={total}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Request;
